/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ErrorInformation } from '../model/errorInformation';
import { Tag } from '../model/tag';
import { TagCreateRequest } from '../model/tagCreateRequest';
import { TagListResponse } from '../model/tagListResponse';
import { TagSearchRequest } from '../model/tagSearchRequest';
import { TagSearchResponse } from '../model/tagSearchResponse';
import { TagUpdateRequest } from '../model/tagUpdateRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class TagService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createTag
     * Creates a new tag.
     * @param tagCreateRequest the information needed to create the tag
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tagCreateTag(tagCreateRequest: TagCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<Tag>;
    public tagCreateTag(tagCreateRequest: TagCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Tag>>;
    public tagCreateTag(tagCreateRequest: TagCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Tag>>;
    public tagCreateTag(tagCreateRequest: TagCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (tagCreateRequest === null || tagCreateRequest === undefined) {
            throw new Error('Required parameter tagCreateRequest was null or undefined when calling tagCreateTag.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Tag>(`${this.configuration.basePath}/tags`,
            tagCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteTag
     * Deletes an existing tag.
     * @param tagTypeCode the tag type code
     * @param tagCode the tag code
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tagDeleteTag(tagTypeCode: string, tagCode: string, observe?: 'body', reportProgress?: boolean): Observable<Tag>;
    public tagDeleteTag(tagTypeCode: string, tagCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Tag>>;
    public tagDeleteTag(tagTypeCode: string, tagCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Tag>>;
    public tagDeleteTag(tagTypeCode: string, tagCode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (tagTypeCode === null || tagTypeCode === undefined) {
            throw new Error('Required parameter tagTypeCode was null or undefined when calling tagDeleteTag.');
        }
        if (tagCode === null || tagCode === undefined) {
            throw new Error('Required parameter tagCode was null or undefined when calling tagDeleteTag.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<Tag>(`${this.configuration.basePath}/tags/tagTypes/${encodeURIComponent(String(tagTypeCode))}/tagCodes/${encodeURIComponent(String(tagCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getTag
     * Gets an existing tag.
     * @param tagTypeCode the tag type code
     * @param tagCode the tag code
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tagGetTag(tagTypeCode: string, tagCode: string, observe?: 'body', reportProgress?: boolean): Observable<Tag>;
    public tagGetTag(tagTypeCode: string, tagCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Tag>>;
    public tagGetTag(tagTypeCode: string, tagCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Tag>>;
    public tagGetTag(tagTypeCode: string, tagCode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (tagTypeCode === null || tagTypeCode === undefined) {
            throw new Error('Required parameter tagTypeCode was null or undefined when calling tagGetTag.');
        }
        if (tagCode === null || tagCode === undefined) {
            throw new Error('Required parameter tagCode was null or undefined when calling tagGetTag.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Tag>(`${this.configuration.basePath}/tags/tagTypes/${encodeURIComponent(String(tagTypeCode))}/tagCodes/${encodeURIComponent(String(tagCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getTags
     * Retrieves all associated tags for the specified tag type code. When tagCode is null, return all tags of the tag type code, which has no parent (i.e. root tags). When tagCode is provided, return all tags of the tag type code and whose parent tag code is tagCode.
     * @param tagTypeCode the tag type&#39;s code.
     * @param tagCode the parent tag code.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tagGetTags(tagTypeCode: string, tagCode?: string, observe?: 'body', reportProgress?: boolean): Observable<TagListResponse>;
    public tagGetTags(tagTypeCode: string, tagCode?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TagListResponse>>;
    public tagGetTags(tagTypeCode: string, tagCode?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TagListResponse>>;
    public tagGetTags(tagTypeCode: string, tagCode?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (tagTypeCode === null || tagTypeCode === undefined) {
            throw new Error('Required parameter tagTypeCode was null or undefined when calling tagGetTags.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tagCode !== undefined && tagCode !== null) {
            queryParameters = queryParameters.set('tagCode', <any>tagCode);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<TagListResponse>(`${this.configuration.basePath}/tags/tagTypes/${encodeURIComponent(String(tagTypeCode))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * searchTags
     * Retrieves all tags existing in the system per specified search filters and keys. For each tag entity, this endpoint returns tag key by default along with any other top-level elements as specified by the \&quot;fields\&quot; query string parameter. The list of tags returned by this endpoint is sorted alphabetically by tag&#39;s display name ascending.
     * @param tagSearchRequest the tag search request. The request can only accept a single search filter and a single search key
     * @param fields the field options for the tag type search response. The valid field options are: displayName, description, parentTagKey, hasChildren
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tagSearchTags(tagSearchRequest: TagSearchRequest, fields?: string, observe?: 'body', reportProgress?: boolean): Observable<TagSearchResponse>;
    public tagSearchTags(tagSearchRequest: TagSearchRequest, fields?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TagSearchResponse>>;
    public tagSearchTags(tagSearchRequest: TagSearchRequest, fields?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TagSearchResponse>>;
    public tagSearchTags(tagSearchRequest: TagSearchRequest, fields?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (tagSearchRequest === null || tagSearchRequest === undefined) {
            throw new Error('Required parameter tagSearchRequest was null or undefined when calling tagSearchTags.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (fields !== undefined && fields !== null) {
            queryParameters = queryParameters.set('fields', <any>fields);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<TagSearchResponse>(`${this.configuration.basePath}/tags/search`,
            tagSearchRequest,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateTag
     * Updates an existing tag.
     * @param tagTypeCode the tag type code
     * @param tagCode the tag code
     * @param tagUpdateRequest the information needed to update the tag
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tagUpdateTag(tagTypeCode: string, tagCode: string, tagUpdateRequest: TagUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<Tag>;
    public tagUpdateTag(tagTypeCode: string, tagCode: string, tagUpdateRequest: TagUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Tag>>;
    public tagUpdateTag(tagTypeCode: string, tagCode: string, tagUpdateRequest: TagUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Tag>>;
    public tagUpdateTag(tagTypeCode: string, tagCode: string, tagUpdateRequest: TagUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (tagTypeCode === null || tagTypeCode === undefined) {
            throw new Error('Required parameter tagTypeCode was null or undefined when calling tagUpdateTag.');
        }
        if (tagCode === null || tagCode === undefined) {
            throw new Error('Required parameter tagCode was null or undefined when calling tagUpdateTag.');
        }
        if (tagUpdateRequest === null || tagUpdateRequest === undefined) {
            throw new Error('Required parameter tagUpdateRequest was null or undefined when calling tagUpdateTag.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Tag>(`${this.configuration.basePath}/tags/tagTypes/${encodeURIComponent(String(tagTypeCode))}/tagCodes/${encodeURIComponent(String(tagCode))}`,
            tagUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
